// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { currentBillingAddressStyles } from "@awc/Overrides/Widgets/Addresses/CurrentBillingAddress";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color } from "@awc/XDL/Utilities";
import { css } from "styled-components";

currentBillingAddressStyles.gridContainer = {
    gap: 0,
};

currentBillingAddressStyles.headingText = { variant: "h3" };

currentBillingAddressStyles.editLink = {
    typographyProps: {
        size: fontConfig.fontSize.small,
        css: css`
            line-height: 19px;
        `,
    },
    css: css`
        margin-left: 32px;
    `,
};

currentBillingAddressStyles.requiredText = {
    css: css`
        margin-bottom: 20px;

        &:before {
            content: "*";
            color: ${color("danger")};
        }
    `,
};
